export const emptyObject = obj => {
    return Object.keys(obj).length === 0;
}